<template>
  <div class="box">
    <!-- 头部整体盒子 -->
    <div id="header" class="container-fluid">
      <!-- 头部顶部  -->
      <div class="header-nav container-fluid row">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="@/assets/img/WMSTitle.png" alt="导航logo" />
        </div>

        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="(index ? index == navIndex : index == navIndex1) ? 'active' : ''"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
        <div class="contact">
          <img src="@/assets/img/contact.png" alt="联系图片" />
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    navIndex1() {
      getter: {
        return this.$store.state.headerContent1
      }
      setter: {
      }
    },
    navIndex: {
      get() {
        return this.$store.state.headerContent
      },
      set() {}
    }
  },
  name: 'Header',
  data() {
    return {
      navOffsetTop: 0,
      menuName: '首页',
      menuClass: 'glyphicon glyphicon-menu-down',

      navList: [
        {
          name: '首页',
          path: '/',
          children: []
        },
        {
          name: '关于民信',
          path: '/about',
          children: [
            {
              name: '企业概况',
              path: '/about/dm1',
              children: []
            },
            {
              name: '企业荣誉',
              path: '/about/dm2',
              children: []
            },
            {
              name: '企业文化',
              path: '/about/dm3',
              children: []
            },
            {
              name: '组织架构',
              path: '/about/dm4',
              children: []
            },
            {
              name: '企业大事记',
              path: '/about/dm5',
              children: []
            },
            {
              name: '热力风采',
              path: '/about/dm6',
              children: []
            }
          ]
        },
        {
          name: '党建工作',
          path: '/party',
          children: [
            {
              name: '党建动态',
              path: '/party/1'
            },
            {
              name: '党务工作',
              path: '/party/2'
            },
            {
              name: '党风廉政建设',
              path: '/party/3'
            }
          ]
        },
        {
          name: '新闻中心',
          path: '/news',
          children: [
            {
              name: '企业新闻',
              path: '/news/1'
            },
            {
              name: '通知公告',
              path: '/news/2'
            },
            {
              name: '媒体报道',
              path: '/news/3'
            },
            {
              name: '行业新闻',
              path: '/news/4'
            }
          ]
        },
        {
          name: '项目中心',
          path: '/project',
          children: [
            {
              name: '换热站建设',
              path: '/project/1',
              children: []
            },
            {
              name: '热力管网建设',
              path: '/project/2',
              children: []
            },
            {
              name: '老旧管网改造',
              path: '/project/3',
              children: []
            }
          ]
        },
        {
          name: '安全生产',
          path: '/production',
          children: [
            {
              name: '安全文化',
              path: '/production/1',
              children: []
            },
            {
              name: '安全生产',
              path: '/production/2',
              children: []
            },
            {
              name: '安全宣讲',
              path: '/production/3',
              children: []
            }
          ]
        },
        {
          name: '用户服务',
          path: '/service',
          children: [
            {
              name: '服务理念',
              path: '/service/1',
              children: []
            },
            {
              name: '收费政策',
              path: '/service/2',
              children: []
            },
            {
              name: '缴费流程',
              path: '/service/3',
              children: []
            },
            {
              name: '供停暖流程',
              path: '/service/4',
              children: []
            },
            // {
            //   name: "供热范围",
            //   path: "/service/5",
            //   children: []
            // },
            {
              name: '服务网点',
              path: '/service/6',
              children: []
            },
            {
              name: '供热常识',
              path: '/service/7',
              children: []
            }
          ]
        },
        {
          name: '我要反馈', //feedback
          path: '/feedback',
          children: []
        },
        {
          name: '联系我们',
          path: '/contactus',
          children: [
            {
              name: '招贤纳士',
              path: '/contactus/1',
              children: []
            }
          ]
        }
      ]
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.fiexdNav)
    this.getData()
    window.addEventListener('popstate', this.handleBackButton)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  destroyed() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.fiexdNav)
  },
  beforeDestroy() {
    // 清理监听器
    window.removeEventListener('popstate', this.handleBackButton)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    handleBackButton() {
      this.$store.commit('updateHeaderContent', null)
      this.$store.commit('updateHeaderContent1', null)
    },
    handleBeforeUnload() {
      this.$store.commit('updateHeaderContent', null)
      this.$store.commit('updateHeaderContent1', null)
    },

    getData() {
      this.navOffsetTop = document.querySelector('.container-fluid').offsetTop
    },
    fiexdNav() {
      // 2.获取当前页面的卷曲高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const nav = document.querySelector('.container-fluid')
      // 3.判断卷曲高度是否大于等于导航条的offsetTop值
      if (scrollTop > this.navOffsetTop) {
        //   3.1若满足，则给nav导航添加固定样式
        nav.classList.add('fixedNav')
      } else {
        //   3.2若不满足，则删除nav导航的固定样式
        nav.classList.remove('fixedNav')
      }

      /** 当滚动到一定区域时给导航项添加选中样式 **/
      //  1.获取所有锚点元素
      const contents = document.querySelectorAll('.header-nav container hidden-xs>div')
      // 2.获取锚点元素的offsetTop值，并收集在一个数组
      const contentsOffsetTop = []
      contents.forEach(item => {
        contentsOffsetTop.push(item.offsetTop)
      })
      // 3.获取页面高度
      const pageHeight = window.innerHeight
      // 4.获取nav的子元素
      const navChildren = document.querySelectorAll('.container-fluid ul')
      // 5.遍历锚点元素的offsetTop值
      for (let i = 0; i < contentsOffsetTop.length; i++) {
        // 5.1 设置第一项导航默认为选中状态
        if (i === 0) {
          navChildren[0].classList.add('active')
        } else if (scrollTop > contentsOffsetTop[i - 1] + pageHeight / 3) {
          // 排他思想
          for (let j = 0; j < contentsOffsetTop.length; j++) {
            navChildren[j].classList.remove('active')
            navChildren[i].classList.add('active')
          }
        } else {
          navChildren[i].classList.remove('active')
        }
      }
    },
    skipTo(selector) {
      const navHeight = document.querySelector('.container-fluid ').offsetHeight
      // scrollIntoView() ///js原生方法，实现锚点滚动过渡
      const target = document.querySelector(selector)
      target.scrollIntoView({ behavior: 'auto' })
      // scrollTo() 把内容滚动到指定的坐标。减去导航高度的目的：导航用定位固定在顶部，如果不减去，导航栏会遮挡一部分内容
      window.scrollTo(0, target.offsetTop - navHeight)
    },

    navClick(index, name) {
      this.navIndex = index
      this.menuName = name
      this.$store.commit('updateHeaderContent', index)
      this.$store.commit('updateHeaderContent1', index)
      this.$store.commit('updateHeaderColor', index)
    },
    menuClick() {
      if (this.menuClass == 'glyphicon glyphicon-menu-down') {
        this.menuClass = 'glyphicon glyphicon-menu-up'
      } else {
        this.menuClass = 'glyphicon glyphicon-menu-down'
      }
    }
  }
}
</script>
<style>
/* 顶部background: #004ea2; */
#header {
  width: 100%;
  height: 95px;
}

.box {
  height: 95px;
  width: 100%;
  background: rgb(253, 253, 253);
}

.fixedNav {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.contact {
  width: 180px;
  height: 55px;
  padding-left: 25px;
}

.contact img {
  width: 180px;
  height: 55px;
  padding-top: 5px;
}

#header .header-top {
  height: 50px;
  color: #ffffff;
  font-size: 15px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  /* float: right; */
  height: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-bottom: 4px solid #f18800;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 300px;
  height: 100%;
  /* float: left; */
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 280px;
  height: 65px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
  width: 100%;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;

  /* margin: 0 200px 0 200px; */
  max-width: 100%;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 10px;
  position: relative;
  padding-top: 10px;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: black;
  font-size: 17px;
  padding: 15px 0;
  position: relative;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.5s ease;
  background-color: #f18800;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 1s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #f18800;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #f18800;
  text-decoration: none;
  border-bottom: 2px solid #f18800;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 120px;
  top: 91%;
  left: -20px;
  z-index: 999999;
  background: rgb(253, 253, 253);
  text-align: center;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 6px;
  border-bottom: 1px solid #ccc;
}

#header .header-nav .header-nav-wrapper > li > {
  border-bottom: 1px solid #f18800;
}

/* 导航栏 每个导航下面的二级导航容器的字体颜色*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: rgb(0, 0, 0);
  font-size: 15px;
  text-decoration: none;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #f18800;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue